export const SET_ALL_SEGMENTS = 'SET_ALL_SEGMENTS';
export const SET_MESSAGE_CONTENT = 'SET_MESSAGE_CONTENT';
export const SET_ALL_MESSAGE_TEMPLATES = 'SET_ALL_MESSAGE_TEMPLATES';
export const SET_MESSAGE_TEMPLATE_DETAIL = 'SET_MESSAGE_TEMPLATE_DETAIL';
export const UPDATE_MESSAGE_CONTENT = 'UPDATE_MESSAGE_CONTENT';
export const UPDATE_MESSAGE_CONTENT_ID = 'UPDATE_MESSAGE_CONTENT_ID';
export const CREATE_SEGMENT_FROM_S3 = 'CREATE_SEGMENT_FROM_S3';
export const CREATE_SEGMENT_FROM_FILE = 'CREATE_SEGMENT_FROM_FILE';
export const CREATE_SEGMENT_FROM_RULES = 'CREATE_SEGMENT_RULES';
export const GET_ALL_TEMPLATES_TRACKER = 'GET_ALL_TEMPLATES_TRACKER';
export const SET_SELECTED_TEMPLATE = 'SET_SELECTED_TEMPLATE';
export const UPDATE_TEMPLATE_SUBJECT = 'UPDATE_TEMPLATE_SUBJECT';
export const RESET_TEMPLATE_FORM = 'RESET_TEMPLATE_FORM';
export const UPDATE_FORM_TYPE = 'UPDATE_FORM_TYPE';
export const UPDATE_TEMPLATE_NAME = 'UPDATE_TEMPLATE_NAME';
export const UPDATE_TEMPLATE_CREATE_STATUS = 'UPDATE_TEMPLATE_CREATE_STATUS';
export const UPDATE_TEMPLATE_EDIT_STATUS = 'UPDATE_TEMPLATE_EDIT_STATUS';
export const UPDATE_TEMPLATE_DELETE_STATUS = 'UPDATE_TEMPLATE_DELETE_STATUS';
